import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import { useAuthStore } from '@/stores/authStore';

// Layout
import Layout from '@/components/layout/Layout';

// Pages
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Users from '@/pages/Users';
import Tenants from '@/pages/Tenants';
import Devices from '@/pages/Devices';
import DeviceLogs from '@/pages/DeviceLogs';
import Parkings from '@/pages/Parkings';
import MqttUI from '@/pages/MqttUI';
import System from '@/pages/System';
import Payments from '@/pages/Payments';
import NotFound from '@/pages/NotFound';

// Protected route component
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuthStore();
  const location = useLocation();
  
  if (!isAuthenticated) {
    // Save the intended destination so we can redirect after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  return <>{children}</>;
};

const App: React.FC = () => {
  return (
    <Router>
      <Box minH="100vh">
        <Routes>
          <Route path="/login" element={<Login />} />
          
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="users" element={<Users />} />
            <Route path="tenants" element={<Tenants />} />
            <Route path="devices" element={<Devices />} />
            <Route path="device-logs" element={<DeviceLogs />} />
            <Route path="parkings" element={<Parkings />} />
            <Route path="payments" element={<Payments />} />
            <Route path="mqtt" element={<MqttUI />} />
            <Route path="system" element={<System />} />
          </Route>
          
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Box>
    </Router>
  );
};

export default App; 